import React, {FC} from "react"
import StockType from "@irati/stock/enums/StockType"
import {Voucher} from "@irati/deals/types"
import {DealExternalLinks} from "@irati/types"
import Url from "./Url"
import Code from "./Code"
import File from "./File"

interface Props {
  voucher: Voucher,
  redemptionId: string,
  externalLinks: DealExternalLinks
}

const Ticket:FC<Props> = ({voucher, redemptionId, externalLinks}) => {
  switch (voucher.type) {
    case StockType.PDF:
    case StockType.URL:
      return <Url voucher={voucher} redemptionId={redemptionId} externalLinks={externalLinks} />
    case StockType.FILE:
      return <File voucher={voucher} />
    default:
      return <Code voucher={voucher} externalLinks={externalLinks} />
  }
}

export default Ticket
